app.service('productCompare', function(
	productsInComparison, productsInComparisonChecker,
	productCompareBar,
	broker,
	front,
	log
) {
	let $buttons;

	function handleAddToCompareClick() {
		productsInComparison.update();

		const $button = $(this);
		const productId = '' + $button.data('product-id');
		const groupId = '' + $button.data('product-group');
		const plu = '' + $button.data('product-plu');

		if (productsInComparison.has(productId)) {
			productsInComparison.remove({ productId });
		} else {
			const productPhoto =
				$button.data('product-photo')
					? $button.data('product-photo')
					: $button
							.closest('.item')
							.find('.product-photo img')
							.attr('src');

			const productAdded = productsInComparison.add({
				groupId,
				productPhoto,
				productId
			});
			log.recommendationsForAWS({
				productPlu: plu,
				eventCategory: 'Porównanie',
				eventAction: 'Porównaj'
			});
		}
		productCompareBar.setGroup(groupId);
		productCompareBar.updateView();
		productsInComparisonChecker.group(groupId);

		broker.trigger('ADD_TO_COMPARE_CLICK');

		UA.pageInteraction('Porównanie', 'Porównanie produktu');
	}

	function setCompareButtons() {
		$buttons = $('.js-compare-add');

		$buttons.each(function() {
			const $button = $(this);
			const groupId = '' + $button.data('product-group');
			productsInComparisonChecker.group(groupId);
		});
	}

	function setEvents() {
		$('body').on('click', '.js-compare-add', handleAddToCompareClick);

		broker.on('REMOVE_FROM_COMPARISON', (e, productId) => {
			productsInComparisonChecker.product(productId);
		});
	}

	function init() {
		setEvents();
		productsInComparison.init();
		setCompareButtons();
		productCompareBar.init();
	}

	return {
		init
	};
});
